import canBlockCharacterCreator from "./canBlockCharacterCreator";
import readDiscoverCharacterRatingScore from "./readDiscoverCharacterRatingScore";
import resolveLocalizedField from "./resolveLocalizedField";
const RATING_PERCENT_MULTIPLIER = 100;
export const readCharacterId = (character) => character.character_id || character.id;
const buildRatingPercent = (ratingScore) => Math.round(readDiscoverCharacterRatingScore(ratingScore) * RATING_PERCENT_MULTIPLIER);
const buildStats = (character) => ({
    messageCount: character.num_messages,
    ratingPercent: buildRatingPercent(character.rating_score),
    tokenCount: character.token_count,
});
/** Guests and signed-in viewers get the same card; only the block permission depends on the viewer. */
export default function buildDiscoverChatbotCardViewModel({ character, onlyUserId, language, blurNSFW, likedBots, hasVoiceAttachment, isLorebookIndicatorEnabled, }) {
    const characterId = readCharacterId(character);
    const name = resolveLocalizedField({ localizedValues: character.name_i18n, language, fallback: character.name });
    const description = resolveLocalizedField({ localizedValues: character.title_i18n, language, fallback: character.title }) || undefined;
    return {
        characterId,
        name,
        description,
        avatarUrl: character.avatar_url,
        isAvatarBlurred: blurNSFW && character.avatar_is_nsfw,
        creatorUsername: character.creator_username || undefined,
        tags: character.tags ?? [],
        hasLorebook: isLorebookIndicatorEnabled && Boolean(character.has_lorebooks),
        hasVoice: hasVoiceAttachment && Boolean(character.voice_id),
        isRecommended: Boolean(character.recommId),
        isFavorite: likedBots.includes(characterId),
        isDefinitionVisible: Boolean(character.definition_visible),
        canBlockCreator: canBlockCharacterCreator({ character, onlyUserId }),
        stats: buildStats(character),
    };
}
